import Vue from 'vue';
import inViewportDirective from 'vue-in-viewport-directive';
import App from '@src/app.vue';
import store from '@state/store';
import router from '@router';
import { i18n } from './localization';
import './globalComponents';

import './external';

Vue.config.productionTip = false;

Vue.mixin({
  data() {
    return {
      baseUrl: process.env.VUE_APP_PUBLIC_PATH,
    };
  },
  computed: {
    ...mapGetters('application', [
      'getAppSize',
      'appIsLarge',
      'appIsSmall',
      'appIsMobile',
      'appIsTablet',
      'appIsExtraLarge',
      'isMac',
      'isLinkGameCenter',
      'getCurrentLang',
    ]),
  },
  methods: {
    scrollToElement(id, offset = -200, behaviour = 'smooth') {
      if (id) {
        const el = document.getElementById(id);
        if (el) {
          window.scrollTo({
            top: window.pageYOffset + el.getBoundingClientRect().top + offset,
            behavior: behaviour,
          });
        }
      }
    },
  },
});

Vue.directive('in-viewport', inViewportDirective);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
